import React, { useState, useContext } from "react";
import { Modal, Input, Space, Form, Checkbox } from "antd";
import { Link } from 'react-router-dom';
import { Context } from '../../../contexts/Account'
import ForgotPassword from "./ForgotPassword";
import { GoogleLogin } from 'react-google-login';
function Login({ loginVisible, setLoginVisible }) {
    const [forgotPasswordVisible, setForgotPasswordVisible] = useState(false);
    const { onLoginAccount } = useContext(Context);

    const handleCancel = () => {
        setLoginVisible(false);
        
    };
    const showForgotPasword = () => {
        setForgotPasswordVisible(true);
        setLoginVisible(false);

    };
    const onClickRegister = () => {
        window.location.assign("/register")
    }
    
    const onFinish = (values) => {
        onLoginAccount(values);
        
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    const responseGoogle = (response) => {
        // console.log(response);
    }
    return (
        <div className="modalBox">

            <Modal
                destroyOnClose={true}
                title="Đăng nhập bằng tài khoản"
                className=" modalLogin modalStyle "
                visible={loginVisible}
                onCancel={handleCancel}
                footer={null}
            >
                <Form
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}>
                    <div className="loginWithFbGoogle">
                        <div className="LoginWithFb">
                            <button className="BtnLoginWith btnLoginWithFb">
                                <img className="img-fluid" src="/images/ic_facebook.png" alt="" /> FaceBook
                            </button>
                        </div>
                        <div className="LoginWithGoogle">
                            <GoogleLogin
                                clientId="658977310896-knrl3gka66fldh83dao2rhgbblmd4un9.apps.googleusercontent.com"
                                render={renderProps => (
                                    <button className="BtnLoginWith btnLoginWithGoogle" onClick={renderProps.onClick} disabled={renderProps.disabled}>
                                        <img className="img-fluid" src="/images/ic_google.png" alt="" /> Google
                                    </button>
                                )}
                                buttonText="Login"
                                onSuccess={responseGoogle}
                                onFailure={responseGoogle}
                                cookiePolicy={'single_host_origin'}
                                isSignedIn={true}
                            />

                        </div>
                    </div>
                    <Form.Item className="formInput"
                        label="EMAIL HOẶC SỐ ĐIỆN THOẠI"
                        name="email"
                        rules={[
                            {
                                required: true,
                                message: 'Please input your email or your phone!',
                            }
                        ]}
                    >
                        <Input
                            type="text"
                            placeholder="Nhập email hoặc số điện thoại"
                        />
                    </Form.Item>
                    <Form.Item className="formInput password"
                        label="MẬT KHẨU"
                        name="password"
                        rules={[
                            {
                                required: true,
                                message: 'Please input your password!',
                            }
                        ]}
                    >
                        <Space direction="vertical">
                            <Input.Password placeholder="input password" />
                        </Space>
                    </Form.Item>
                    <div className="remember_forgotPassword">
                        <Form.Item className="formInput remember"
                            name="remember"
                            valuePropName="checked"
                            rules={[
                                {
                                    required: false
                                }
                            ]}
                        >
                            <Checkbox>Ghi nhớ</Checkbox>
                        </Form.Item>
                        <Link className="formInput forgotPass" onClick={showForgotPasword}>Quên mật khẩu</Link>
                    </div>

                    <Form.Item className="btnModal">
                        <button className="btnStyle">
                            Đăng nhập
                        </button>
                    </Form.Item>
                    <div className="register">Chưa có tài khoản? <Link to="/register">Đăng ký</Link></div>
                </Form>
            </Modal>
            <ForgotPassword forgotPasswordVisible={forgotPasswordVisible} setForgotPasswordVisible={setForgotPasswordVisible} setLoginVisible={setLoginVisible} />
        </div>
    )

}
export default Login;